import { PathOptions } from "leaflet";

export const linhas_de_trem_do_grande_recife = (_feature: any): PathOptions => {
  return {
    color: "#F4A22D",
    weight: 2,
    opacity: 1,
    dashArray: "8 4",
  };
};
